import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

// Register ag-grid community modules once for the entire app.
ModuleRegistry.registerModules([AllCommunityModule]);
import {
  provideRouter,
  withHashLocation,
  withRouterConfig,
} from '@angular/router';

import { providePrimeNG } from 'primeng/config';
import { environment } from 'src/environments/environment';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';

import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';

import { createMongoAbility, PureAbility } from '@casl/ability';
import { BASE_URL, msalInstance, scopes } from '@tw/lib';
import { MessageService } from 'primeng/api';
import { AuthInterceptor } from 'src/shared/interceptors/auth.interceptor';
import { AppAbility } from 'src/shared/models/permissions';
import { customThemePreset } from './app-theme';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withHashLocation(),
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: customThemePreset,
        options: {
          darkModeSelector: '.tw-dark',
        },
      },
      inputVariant: 'outlined',
      inputStyle: 'outlined',
      ripple: true,
    }),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      MsalModule.forRoot(
        msalInstance,
        {
          interactionType: InteractionType.Redirect,
          authRequest: { scopes },
        },
        {
          interactionType: InteractionType.Redirect,
          protectedResourceMap: new Map([
            ['https://graph.microsoft.com/v1.0/me', scopes],
          ]),
        },
      ),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: BASE_URL,
      useValue: environment.apiUrl,
    },
    {
      provide: PureAbility,
      useValue: createMongoAbility<AppAbility>(),
    },
    // PrimeNG providers
    MessageService,
  ],
};
